export function deriveBrokerSnapshotAvailability({
  tokenRow,
  tokenError,
  positionRows,
  positionError,
}) {
  const hasPositions = Array.isArray(positionRows) && positionRows.length > 0
  const hasAuthSignal = Boolean(tokenRow)

  if (positionError) {
    return {
      connected: hasAuthSignal || hasPositions ? true : null,
      loadError: hasAuthSignal || hasPositions
        ? 'Could not load Schwab positions. Try again.'
        : 'Could not verify the Schwab connection or load positions.',
    }
  }
  if (tokenRow || hasPositions) {
    return { connected: true, loadError: null }
  }
  if (tokenError) {
    return {
      connected: null,
      loadError: 'Could not verify the Schwab connection or load positions.',
    }
  }
  return { connected: false, loadError: null }
}
